import { render, staticRenderFns } from "./KaoguanPicker.vue?vue&type=template&id=bace1a8a&"
import script from "./KaoguanPicker.vue?vue&type=script&lang=js&"
export * from "./KaoguanPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports